import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import Table from "../../../FlowConfigurationInputs/Table/Table";

/**
 * @Description this page Active Directory  Library's   AddUserToGroup  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */

function AddUserToGroup({
  action,
  variables,
  setOpenVariable,
  variableRender,
  automVersionId
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.";
  const headers = [label + "USERNAME"];
  const options = {
    tableBody: { headers, title: label + "USERS" },
  };
  return (
    <div>
      <div className="form-element" style={{ width: "95%" }}>
        <Table
          action={action}
          inputName="users"
          automVersionId={automVersionId}
          options={options.tableBody}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          isActiveDirectory={true}
        />
      </div>
      <div className="form-element">
        {t(
          "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.ADD-GROUP.GROUP-NAME"
        )}
        <TextInput
          action={action}
          isRequired={false}
          inputName="groupName"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          fieldType='string' displayName={t('CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.ADD-GROUP.GROUP-NAME')}
        />
      </div>
    </div>
  );
}

export default AddUserToGroup;
